import { createFileRoute } from "@tanstack/react-router";
import ConnectorsPage from "@/features/connectors/ConnectorsPage";

export const Route = createFileRoute("/_admin/connectors/")({
  component: ConnectorsPage,
});
